import { Column } from 'src/model';
import { contactColumnList } from 'src/utils/tableColumns';

export const SET_CONTACT_COLUMNS = 'SET_CONTACT_COLUMNS';
export const setTPContactsColumns = (columns: Column[]) => ({
  type: SET_CONTACT_COLUMNS,
  payload: columns,
});

const initialState: Column[] = contactColumnList;

interface Action {
  type: string;
  payload: Column[];
}

const setTPContactsColumnsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_CONTACT_COLUMNS:
      return [...action.payload];

    default:
      return state;
  }
};
export default setTPContactsColumnsReducer;
